// ABOUTME: Reads the explain endpoint's answer: how many nodes a read filter keeps and its Neo4j plan as indented lines.
// ABOUTME: The payload is untyped JSON, so every field is checked rather than assumed.

export interface ExplainResult {
    count: number;
    /** the plan operators, one per line, with their depth in the plan tree */
    plan: { operator: string; depth: number }[];
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

/** Neo4j suffixes the operator with the runtime (`NodeByLabelScan@neo4j`): only the name is shown. */
const operatorName = (operatorType: string) => operatorType.split('@')[0];

const planLines = (node: unknown, depth: number): ExplainResult['plan'] => {
    if (!isRecord(node)) {
        return [];
    }
    const own =
        typeof node.operatorType === 'string'
            ? [{ operator: operatorName(node.operatorType), depth }]
            : [];
    const children = Array.isArray(node.children) ? node.children : [];
    return [...own, ...children.flatMap(child => planLines(child, depth + 1))];
};

/** The explain answer, or undefined when the payload is not one. */
export const parseExplainResult = (payload: unknown): ExplainResult | undefined => {
    if (!isRecord(payload) || typeof payload.count !== 'number') {
        return undefined;
    }
    return { count: payload.count, plan: planLines(payload.plan, 0) };
};

/** The message of an error payload (`{ message }`), else the fallback. */
export const errorMessageOf = (payload: unknown, fallback: string): string =>
    isRecord(payload) && typeof payload.message === 'string' ? payload.message : fallback;
